import { ReactComponent as NotFoundIcon } from '../../icons/notFound.svg';

export function NotFound() {
    return (
        <div className='flex h-full max-h-full flex-col gap-2 justify-center items-center p-6'>
            <NotFoundIcon />
            <span className='text-heading-sm text-center font-semibold text-neutral-600'>Nessun risultato trovato</span>
            <span className='text-text-lg text-center text-neutral-500'>Non siamo riusciti a trovare quello che stavi cercando</span>
        </div>
    )
}
